import Observer from '@capsule/observer'
import TrackElements from '@capsule/track-elements'
import {
	setBatchEvents,
	setBatchEventsArticleWall
} from 'front/shared/assets/scripts/setBatchEvents'
import PmcBridge from 'shared/services/pmc-bridge'

export default class ArticleWall {
	articleContainer: HTMLElement | null
	wallArticle: HTMLElement | null
	paidArticle: HTMLElement | null
	wrapperWall: HTMLElement | null
	PMCBrige: PmcBridge
	isUserSubscribed: boolean
	subscription: string[]
	trackElements: TrackElements | null

	constructor() {
		this.articleContainer = document.querySelector('.article')
		this.wallArticle = document.getElementById('articleWall')
		this.paidArticle = document.getElementById('articleWall-paid')
		this.wrapperWall = document.getElementById('articleWall-wrapper')
		this.PMCBrige = new PmcBridge()
		this.isUserSubscribed = false
		this.subscription = []
		this.trackElements = null
	}

	async init() {
		this.isUserSubscribed = await this.PMCBrige.hasSubscription()
		this.subscription = await this.PMCBrige.getAllSubscriptions()

		if (this.isUserSubscribed) {
			this.unlockArticle()
		} else {
			this.addTrackingWall()
		}

		setBatchEvents(() => setBatchEventsArticleWall(this.isUserSubscribed, this.subscription))
	}

	private unlockArticle() {
		this.wallArticle?.classList.add('unlocked')
		this.paidArticle?.removeAttribute('hidden')
		this.wrapperWall?.setAttribute('hidden', '')
		this.initEmbed()
	}

	private initEmbed() {
		const firstEmbed = this.articleContainer?.querySelector('[data-site]')
		firstEmbed && this.onFirstEmbedIntersection(firstEmbed)
	}

	/**
	 * On first embed intersection actions
	 */
	private onFirstEmbedIntersection(firstEmbed: Element): void {
		const observer = new Observer({
			elements: firstEmbed,
			onIntersection: this.initEmbedPaidScripts
		})

		observer.observe()
	}

	private initEmbedPaidScripts(): void {
		const dataEmbedPaid = document.getElementById('template-embedScriptPaid')

		if (dataEmbedPaid instanceof HTMLTemplateElement) {
			const embedScriptPaid = dataEmbedPaid.content.cloneNode(true)
			document.body.appendChild(embedScriptPaid)
			dataEmbedPaid.remove()
		}
	}

	private addTrackingWall() {
		const wallButtonOffer = document.getElementById('wall-button-offer')

		this.trackElements = new TrackElements([
			{
				element: this.wallArticle,
				display: {
					event: 'button_display',
					button_name: 'cta-paywall',
					button_label: "Je découvre l'offre"
				}
			},
			{
				element: wallButtonOffer,
				click: {
					event: 'button_click',
					button_name: 'cta-paywall',
					button_label: "Je découvre l'offre"
				}
			}
		])
		this.trackElements.init()
	}
}
